import DatabaseModel from './DatabaseModel.js';

var Proveedor = Object.create(DatabaseModel);

Proveedor.model = 'proveedor';
Proveedor.modelFront = 'proveedores';

export default Proveedor;